import { createIcon } from './createIcon';
import PiAI03Solid from './pika/PiAI03Solid';
import PiAI03Stroke from './pika/PiAI03Stroke';
import PiActivityStroke from './pika/PiActivityStroke';
import PiAlertCircleSolid from './pika/PiAlertCircleSolid';
import PiAlertCircleStroke from './pika/PiAlertCircleStroke';
import PiAlertTriangleSolid from './pika/PiAlertTriangleSolid';
import PiAlertTriangleStroke from './pika/PiAlertTriangleStroke';
import PiAlignHorizontalCenterSolid from './pika/PiAlignHorizontalCenterSolid';
import PiAlignHorizontalCenterStroke from './pika/PiAlignHorizontalCenterStroke';
import PiAlignLeftSolid from './pika/PiAlignLeftSolid';
import PiAlignLeftStroke from './pika/PiAlignLeftStroke';
import PiAlignRightSolid from './pika/PiAlignRightSolid';
import PiAlignRightStroke from './pika/PiAlignRightStroke';
import PiAnnotationDefaultSolid from './pika/PiAnnotationDefaultSolid';
import PiAnnotationDefaultStroke from './pika/PiAnnotationDefaultStroke';
import PiArchiveDefaultSolid from './pika/PiArchiveDefaultSolid';
import PiArchiveDefaultStroke from './pika/PiArchiveDefaultStroke';
import PiArrowBigRightSolid from './pika/PiArrowBigRightSolid';
import PiArrowBigRightStroke from './pika/PiArrowBigRightStroke';
import PiArrowBigTurnLeftSolid from './pika/PiArrowBigTurnLeftSolid';
import PiArrowBigTurnLeftStroke from './pika/PiArrowBigTurnLeftStroke';
import PiArrowBigTurnRightSolid from './pika/PiArrowBigTurnRightSolid';
import PiArrowBigTurnRightStroke from './pika/PiArrowBigTurnRightStroke';
import PiArrowDownSolid from './pika/PiArrowDownSolid';
import PiArrowDownStroke from './pika/PiArrowDownStroke';
import PiArrowLeftSolid from './pika/PiArrowLeftSolid';
import PiArrowLeftStroke from './pika/PiArrowLeftStroke';
import PiArrowRightDownStroke from './pika/PiArrowRightDownStroke';
import PiArrowRightSolid from './pika/PiArrowRightSolid';
import PiArrowRightStroke from './pika/PiArrowRightStroke';
import PiArrowRightUpStroke from './pika/PiArrowRightUpStroke';
import PiArrowUpSolid from './pika/PiArrowUpSolid';
import PiArrowUpStroke from './pika/PiArrowUpStroke';
import PiBoldStroke from './pika/PiBoldStroke';
import PiBriefcaseJobSolid from './pika/PiBriefcaseJobSolid';
import PiBriefcaseJobStroke from './pika/PiBriefcaseJobStroke';
import PiBuildingApartmentBigSolid from './pika/PiBuildingApartmentBigSolid';
import PiBuildingApartmentBigStroke from './pika/PiBuildingApartmentBigStroke';
import PiCalendarCheckSolid from './pika/PiCalendarCheckSolid';
import PiCalendarCheckStroke from './pika/PiCalendarCheckStroke';
import PiCalendarDefaultSolid from './pika/PiCalendarDefaultSolid';
import PiCalendarDefaultStroke from './pika/PiCalendarDefaultStroke';
import PiCashSolid from './pika/PiCashSolid';
import PiCashStroke from './pika/PiCashStroke';
import PiChatChattingSolid from './pika/PiChatChattingSolid';
import PiChatChattingStroke from './pika/PiChatChattingStroke';
import PiCheckTickCircleSolid from './pika/PiCheckTickCircleSolid';
import PiCheckTickCircleStroke from './pika/PiCheckTickCircleStroke';
import PiCheckTickSingleStroke from './pika/PiCheckTickSingleStroke';
import PiCheckTickSquareBrokenSolid from './pika/PiCheckTickSquareBrokenSolid';
import PiCheckTickSquareBrokenStroke from './pika/PiCheckTickSquareBrokenStroke';
import PiChevronBigDownSolid from './pika/PiChevronBigDownSolid';
import PiChevronBigDownStroke from './pika/PiChevronBigDownStroke';
import PiChevronBigLeftSolid from './pika/PiChevronBigLeftSolid';
import PiChevronBigLeftStroke from './pika/PiChevronBigLeftStroke';
import PiChevronBigRightSolid from './pika/PiChevronBigRightSolid';
import PiChevronBigRightStroke from './pika/PiChevronBigRightStroke';
import PiClockDefaultSolid from './pika/PiClockDefaultSolid';
import PiClockDefaultStroke from './pika/PiClockDefaultStroke';
import PiColorPaletteSolid from './pika/PiColorPaletteSolid';
import PiColorPaletteStroke from './pika/PiColorPaletteStroke';
import PiCopyDefaultSolid from './pika/PiCopyDefaultSolid';
import PiCopyDefaultStroke from './pika/PiCopyDefaultStroke';
import PiCrownWinnerKingSolid from './pika/PiCrownWinnerKingSolid';
import PiCrownWinnerKingStroke from './pika/PiCrownWinnerKingStroke';
import PiDeleteDustbin01Solid from './pika/PiDeleteDustbin01Solid';
import PiDeleteDustbin01Stroke from './pika/PiDeleteDustbin01Stroke';
import PiDeleteDustbin02Solid from './pika/PiDeleteDustbin02Solid';
import PiDeleteDustbin02Stroke from './pika/PiDeleteDustbin02Stroke';
import PiDiamondComponentSolid from './pika/PiDiamondComponentSolid';
import PiDiamondComponentStroke from './pika/PiDiamondComponentStroke';
import PiDownloadDownSolid from './pika/PiDownloadDownSolid';
import PiDownloadDownStroke from './pika/PiDownloadDownStroke';
import PiDraggableSixDotsStroke from './pika/PiDraggableSixDotsStroke';
import PiEnvelopeDefaultSolid from './pika/PiEnvelopeDefaultSolid';
import PiEnvelopeDefaultStroke from './pika/PiEnvelopeDefaultStroke';
import PiExternalLinkCircleSolid from './pika/PiExternalLinkCircleSolid';
import PiExternalLinkCircleStroke from './pika/PiExternalLinkCircleStroke';
import PiEyeOffSolid from './pika/PiEyeOffSolid';
import PiEyeOffStroke from './pika/PiEyeOffStroke';
import PiEyeOnSolid from './pika/PiEyeOnSolid';
import PiEyeOnStroke from './pika/PiEyeOnStroke';
import PiFaceSmileSolid from './pika/PiFaceSmileSolid';
import PiFaceSmileStroke from './pika/PiFaceSmileStroke';
import PiFileTextSolid from './pika/PiFileTextSolid';
import PiFileTextStroke from './pika/PiFileTextStroke';
import PiFilterFunnelSolid from './pika/PiFilterFunnelSolid';
import PiFilterFunnelStroke from './pika/PiFilterFunnelStroke';
import PiFilterLinesStroke from './pika/PiFilterLinesStroke';
import PiFocusTargetStroke from './pika/PiFocusTargetStroke';
import PiFolderDefaultSolid from './pika/PiFolderDefaultSolid';
import PiFolderDefaultStroke from './pika/PiFolderDefaultStroke';
import PiGiftDefaultSolid from './pika/PiGiftDefaultSolid';
import PiGiftDefaultStroke from './pika/PiGiftDefaultStroke';
import PiGraduationHatSolid from './pika/PiGraduationHatSolid';
import PiGraduationHatStroke from './pika/PiGraduationHatStroke';
import PiHeartSolid from './pika/PiHeartSolid';
import PiHeartStroke from './pika/PiHeartStroke';
import PiHomeDefaultSolid from './pika/PiHomeDefaultSolid';
import PiHomeDefaultStroke from './pika/PiHomeDefaultStroke';
import PiInformationCircleSolid from './pika/PiInformationCircleSolid';
import PiInformationCircleStroke from './pika/PiInformationCircleStroke';
import PiItalicStroke from './pika/PiItalicStroke';
import PiLinkChainSlantStroke from './pika/PiLinkChainSlantStroke';
import PiListLongStroke from './pika/PiListLongStroke';
import PiLockCloseSolid from './pika/PiLockCloseSolid';
import PiLockCloseStroke from './pika/PiLockCloseStroke';
import PiLogInRightSolid from './pika/PiLogInRightSolid';
import PiLogInRightStroke from './pika/PiLogInRightStroke';
import PiLogOutRightSolid from './pika/PiLogOutRightSolid';
import PiLogOutRightStroke from './pika/PiLogOutRightStroke';
import PiMagicWandSolid from './pika/PiMagicWandSolid';
import PiMagicWandStroke from './pika/PiMagicWandStroke';
import PiMessageCheckSolid from './pika/PiMessageCheckSolid';
import PiMessageCheckStroke from './pika/PiMessageCheckStroke';
import PiMicOnSolid from './pika/PiMicOnSolid';
import PiMicOnStroke from './pika/PiMicOnStroke';
import PiMinusCircleSolid from './pika/PiMinusCircleSolid';
import PiMinusCircleStroke from './pika/PiMinusCircleStroke';
import PiMinusDefaultStroke from './pika/PiMinusDefaultStroke';
import PiMultipleCrossCancelCircleSolid from './pika/PiMultipleCrossCancelCircleSolid';
import PiMultipleCrossCancelCircleStroke from './pika/PiMultipleCrossCancelCircleStroke';
import PiMultipleCrossCancelDefaultStroke from './pika/PiMultipleCrossCancelDefaultStroke';
import PiNavigationSlantSolid from './pika/PiNavigationSlantSolid';
import PiNavigationSlantStroke from './pika/PiNavigationSlantStroke';
import PiNoteDefaultSolid from './pika/PiNoteDefaultSolid';
import PiNoteDefaultStroke from './pika/PiNoteDefaultStroke';
import PiNotificationBellOnSolid from './pika/PiNotificationBellOnSolid';
import PiNotificationBellOnStroke from './pika/PiNotificationBellOnStroke';
import PiPaintBrushSolid from './pika/PiPaintBrushSolid';
import PiPaintBrushStroke from './pika/PiPaintBrushStroke';
import PiPaperclipSlantStroke from './pika/PiPaperclipSlantStroke';
import PiPauseCircleSolid from './pika/PiPauseCircleSolid';
import PiPauseCircleStroke from './pika/PiPauseCircleStroke';
import PiPencilEditBoxStroke from './pika/PiPencilEditBoxStroke';
import PiPencilEditSolid from './pika/PiPencilEditSolid';
import PiPencilEditStroke from './pika/PiPencilEditStroke';
import PiPeopleMaleFemaleSolid from './pika/PiPeopleMaleFemaleSolid';
import PiPeopleMaleFemaleStroke from './pika/PiPeopleMaleFemaleStroke';
import PiPeopleMaleMaleSolid from './pika/PiPeopleMaleMaleSolid';
import PiPeopleMaleMaleStroke from './pika/PiPeopleMaleMaleStroke';
import PiPlayCircleSolid from './pika/PiPlayCircleSolid';
import PiPlayCircleStroke from './pika/PiPlayCircleStroke';
import PiPluginAddonPuzzleSolid from './pika/PiPluginAddonPuzzleSolid';
import PiPluginAddonPuzzleStroke from './pika/PiPluginAddonPuzzleStroke';
import PiPlusCircleSolid from './pika/PiPlusCircleSolid';
import PiPlusCircleStroke from './pika/PiPlusCircleStroke';
import PiPlusDefaultStroke from './pika/PiPlusDefaultStroke';
import PiPrinterSolid from './pika/PiPrinterSolid';
import PiPrinterStroke from './pika/PiPrinterStroke';
import PiQuestionMarkCircleSolid from './pika/PiQuestionMarkCircleSolid';
import PiQuestionMarkCircleStroke from './pika/PiQuestionMarkCircleStroke';
import PiQuestionMarkStroke from './pika/PiQuestionMarkStroke';
import PiRefreshSolid from './pika/PiRefreshSolid';
import PiRefreshStroke from './pika/PiRefreshStroke';
import PiRepeatSquareSolid from './pika/PiRepeatSquareSolid';
import PiRepeatSquareStroke from './pika/PiRepeatSquareStroke';
import PiScaleSolid from './pika/PiScaleSolid';
import PiScaleStroke from './pika/PiScaleStroke';
import PiSearchDefaultSolid from './pika/PiSearchDefaultSolid';
import PiSearchDefaultStroke from './pika/PiSearchDefaultStroke';
import PiSendPlaneSlantSolid from './pika/PiSendPlaneSlantSolid';
import PiSendPlaneSlantStroke from './pika/PiSendPlaneSlantStroke';
import PiSettings02Solid from './pika/PiSettings02Solid';
import PiSettings02Stroke from './pika/PiSettings02Stroke';
import PiShare01Solid from './pika/PiShare01Solid';
import PiShare01Stroke from './pika/PiShare01Stroke';
import PiShuffleSolid from './pika/PiShuffleSolid';
import PiShuffleStroke from './pika/PiShuffleStroke';
import PiSidebarLeftCloseStroke from './pika/PiSidebarLeftCloseStroke';
import PiSidebarRightCloseStroke from './pika/PiSidebarRightCloseStroke';
import PiSparkleAI01Solid from './pika/PiSparkleAI01Solid';
import PiSparkleAI01Stroke from './pika/PiSparkleAI01Stroke';
import PiStarSolid from './pika/PiStarSolid';
import PiStarStroke from './pika/PiStarStroke';
import PiStopCircleSolid from './pika/PiStopCircleSolid';
import PiStopCircleStroke from './pika/PiStopCircleStroke';
import PiTagSolid from './pika/PiTagSolid';
import PiTagStroke from './pika/PiTagStroke';
import PiTargetCenterSolid from './pika/PiTargetCenterSolid';
import PiTextParagraphSolid from './pika/PiTextParagraphSolid';
import PiTextParagraphStroke from './pika/PiTextParagraphStroke';
import PiTextStroke from './pika/PiTextStroke';
import PiThreeDotsMenuHorizontalStroke from './pika/PiThreeDotsMenuHorizontalStroke';
import PiThreeDotsMenuVerticalStroke from './pika/PiThreeDotsMenuVerticalStroke';
import PiToolsSolid from './pika/PiToolsSolid';
import PiToolsStroke from './pika/PiToolsStroke';
import PiUnderlineStroke from './pika/PiUnderlineStroke';
import PiUploadUpSolid from './pika/PiUploadUpSolid';
import PiUploadUpStroke from './pika/PiUploadUpStroke';
import PiUserArrowRightStroke from './pika/PiUserArrowRightStroke';
import PiUserCheckStroke from './pika/PiUserCheckStroke';
import PiUserCircleSolid from './pika/PiUserCircleSolid';
import PiUserCircleStroke from './pika/PiUserCircleStroke';
import PiUserLoveHeartSolid from './pika/PiUserLoveHeartSolid';
import PiUserLoveHeartStroke from './pika/PiUserLoveHeartStroke';
import PiUserPlusSolid from './pika/PiUserPlusSolid';
import PiUserPlusStroke from './pika/PiUserPlusStroke';
import PiUserThreeSolid from './pika/PiUserThreeSolid';
import PiUserThreeStroke from './pika/PiUserThreeStroke';
import PiUturnLeftSolid from './pika/PiUturnLeftSolid';
import PiUturnLeftStroke from './pika/PiUturnLeftStroke';
import PiWindowFullscreenSolid from './pika/PiWindowFullscreenSolid';
import PiWindowFullscreenStroke from './pika/PiWindowFullscreenStroke';
import PiWindowGridSolid from './pika/PiWindowGridSolid';
import PiWindowGridStroke from './pika/PiWindowGridStroke';

export * from './pika';
export { createIcon } from './createIcon';
export type { CreatedIcon, IconProps } from './createIcon';

export const ActivityIcon = createIcon(PiActivityStroke);
export const AddIcon = createIcon(PiPlusDefaultStroke);
export const AlertIcon = createIcon(PiAlertCircleStroke, PiAlertCircleSolid);
export const AttachmentIcon = createIcon(PiPaperclipSlantStroke);
export const ArrowDownIcon = createIcon(PiArrowDownStroke, PiArrowDownSolid);
export const ArrowDownRightIcon = createIcon(PiArrowRightDownStroke);
export const ArrowUpIcon = createIcon(PiArrowUpStroke, PiArrowUpSolid);
export const ArrowUpRightIcon = createIcon(PiArrowRightUpStroke);
export const ArrowLeftIcon = createIcon(PiArrowLeftStroke, PiArrowLeftSolid);
export const ArrowRightIcon = createIcon(PiArrowRightStroke, PiArrowRightSolid);
export const ArchiveIcon = createIcon(PiArchiveDefaultStroke, PiArchiveDefaultSolid);
export const BackwardIcon = createIcon(PiArrowLeftStroke, PiArrowLeftSolid);
export const BellIcon = createIcon(PiNotificationBellOnStroke, PiNotificationBellOnSolid);
export const BoldIcon = createIcon(PiBoldStroke);
export const CalendarCheckIcon = createIcon(PiCalendarCheckStroke, PiCalendarCheckSolid);
export const CalendarIcon = createIcon(PiCalendarDefaultStroke, PiCalendarDefaultSolid);
export const CashIcon = createIcon(PiCashStroke, PiCashSolid);
export const CheckmarkIcon = createIcon(PiCheckTickSingleStroke);
export const ChessQueenIcon = createIcon(PiCrownWinnerKingStroke, PiCrownWinnerKingSolid);
export const ChevronDownIcon = createIcon(PiChevronBigDownStroke, PiChevronBigDownSolid);
export const ChevronLeftIcon = createIcon(PiChevronBigLeftStroke, PiChevronBigLeftSolid);
export const ChevronRightIcon = createIcon(PiChevronBigRightStroke, PiChevronBigRightSolid);
export const CircleCheckmarkIcon = createIcon(PiCheckTickCircleStroke, PiCheckTickCircleSolid);
export const SquareCheckmarkIcon = createIcon(
	PiCheckTickSquareBrokenStroke,
	PiCheckTickSquareBrokenSolid,
);
export const CircleRemoveIcon = createIcon(PiMinusCircleStroke, PiMinusCircleSolid);
export const CircleUserIcon = createIcon(PiUserCircleStroke, PiUserCircleSolid);
export const CityIcon = createIcon(PiBuildingApartmentBigStroke, PiBuildingApartmentBigSolid);
export const CloseIcon = createIcon(PiMultipleCrossCancelDefaultStroke);
export const CloseCircleIcon = createIcon(
	PiMultipleCrossCancelCircleStroke,
	PiMultipleCrossCancelCircleSolid,
);
export const ColorPaletteIcon = createIcon(PiColorPaletteStroke, PiColorPaletteSolid);
export const CompassIcon = createIcon(PiDiamondComponentStroke, PiDiamondComponentSolid);
export const ComposeIcon = createIcon(PiPencilEditStroke, PiPencilEditSolid);
export const ComposeTweetIcon = createIcon(PiAnnotationDefaultStroke, PiAnnotationDefaultSolid);
export const ConversationIcon = createIcon(PiChatChattingStroke, PiChatChattingSolid);
export const CopyIcon = createIcon(PiCopyDefaultStroke, PiCopyDefaultSolid);
export const DashIcon = createIcon(PiMinusDefaultStroke);
export const DashboardIcon = createIcon(PiWindowGridStroke, PiWindowGridSolid);
export const DeleteIcon = createIcon(PiDeleteDustbin01Stroke, PiDeleteDustbin01Solid);
export const DialogueIcon = createIcon(PiMessageCheckStroke, PiMessageCheckSolid);
export const DirectionalSignRightIcon = createIcon(PiArrowBigRightStroke, PiArrowBigRightSolid);
export const DocumentIcon = createIcon(PiFileTextStroke, PiFileTextSolid);
export const DownloadIcon = createIcon(PiDownloadDownStroke, PiDownloadDownSolid);
export const DraftsIcon = createIcon(PiNoteDefaultStroke, PiNoteDefaultSolid);
export const EmojiIcon = createIcon(PiFaceSmileStroke, PiFaceSmileSolid);
export const FilterIcon = createIcon(PiFilterLinesStroke);
export const FilteredIcon = createIcon(PiFilterFunnelStroke, PiFilterFunnelSolid);
export const FolderIcon = createIcon(PiFolderDefaultStroke, PiFolderDefaultSolid);
export const ForwardIcon = createIcon(PiArrowBigTurnRightStroke, PiArrowBigTurnRightSolid);
export const FriendsFeminineMasculineIcon = createIcon(
	PiPeopleMaleFemaleStroke,
	PiPeopleMaleFemaleSolid,
);
export const FriendsIcon = createIcon(PiPeopleMaleMaleStroke, PiPeopleMaleMaleSolid);
export const FullScreenIcon = createIcon(PiWindowFullscreenStroke, PiWindowFullscreenSolid);
export const GearIcon = createIcon(PiSettings02Stroke, PiSettings02Solid);
export const GiftIcon = createIcon(PiGiftDefaultStroke, PiGiftDefaultSolid);
export const GridIcon = createIcon(PiWindowGridStroke, PiWindowGridSolid);
export const GroupsIcon = createIcon(PiUserThreeStroke, PiUserThreeSolid);
export const HammerIcon = createIcon(PiToolsStroke, PiToolsSolid);
export const HeartIcon = createIcon(PiHeartStroke, PiHeartSolid);
export const HeartRateIcon = createIcon(PiActivityStroke);
export const HelpIcon = createIcon(PiQuestionMarkCircleStroke, PiQuestionMarkCircleSolid);
export const HistoryIcon = createIcon(PiClockDefaultStroke, PiClockDefaultSolid);
export const HomeIcon = createIcon(PiHomeDefaultStroke, PiHomeDefaultSolid);
export const ItalicIcon = createIcon(PiItalicStroke);
export const InfoAlternateIcon = createIcon(PiInformationCircleStroke, PiInformationCircleSolid);
export const JunkIcon = createIcon(PiDeleteDustbin02Stroke, PiDeleteDustbin02Solid);
export const LibraryIcon = createIcon(PiGraduationHatStroke, PiGraduationHatSolid);
export const DirectionsIcon = createIcon(PiNavigationSlantStroke, PiNavigationSlantSolid);
export const LinkIcon = createIcon(PiLinkChainSlantStroke);
export const ListIcon = createIcon(PiListLongStroke);
export const LockIcon = createIcon(PiLockCloseStroke, PiLockCloseSolid);
export const LogOutIcon = createIcon(PiLogOutRightStroke, PiLogOutRightSolid);
export const MagicWandIcon = createIcon(PiMagicWandStroke, PiMagicWandSolid);
export const MailIcon = createIcon(PiEnvelopeDefaultStroke, PiEnvelopeDefaultSolid);
export const MicrophoneIcon = createIcon(PiMicOnStroke, PiMicOnSolid);
export const MoreAlternateIcon = createIcon(PiThreeDotsMenuHorizontalStroke);
export const MoreIcon = createIcon(PiThreeDotsMenuVerticalStroke);
export const MeetingIcon = createIcon(PiPeopleMaleFemaleStroke, PiPeopleMaleFemaleSolid);
export const NetworkIcon = createIcon(PiShare01Stroke, PiShare01Solid);
export const NewBadgeIcon = createIcon(PiSparkleAI01Stroke, PiSparkleAI01Solid);
export const PaintBrushWideIcon = createIcon(PiPaintBrushStroke, PiPaintBrushSolid);
export const PencilIcon = createIcon(PiPencilEditStroke, PiPencilEditSolid);
export const PencilEditBoxIcon = createIcon(PiPencilEditBoxStroke);
export const PlaybackPauseIcon = createIcon(PiPauseCircleStroke, PiPauseCircleSolid);
export const PlaybackPlayIcon = createIcon(PiPlayCircleStroke, PiPlayCircleSolid);
export const PlaybackStopIcon = createIcon(PiStopCircleStroke, PiStopCircleSolid);
export const PopOutIcon = createIcon(PiExternalLinkCircleStroke, PiExternalLinkCircleSolid);
export const PrintIcon = createIcon(PiPrinterStroke, PiPrinterSolid);
export const PuzzleIcon = createIcon(PiPluginAddonPuzzleStroke, PiPluginAddonPuzzleSolid);
export const QuestionMarkIcon = createIcon(PiQuestionMarkStroke);
export const ReorderIcon = createIcon(PiDraggableSixDotsStroke);
export const RepeatIcon = createIcon(PiRepeatSquareStroke, PiRepeatSquareSolid);
export const ReplyIcon = createIcon(PiArrowBigTurnLeftStroke, PiArrowBigTurnLeftSolid);
export const RulerIcon = createIcon(PiScaleStroke, PiScaleSolid);
export const SearchIcon = createIcon(PiSearchDefaultStroke, PiSearchDefaultSolid);
export const SendIcon = createIcon(PiSendPlaneSlantStroke, PiSendPlaneSlantSolid);
export const ShareIcon = createIcon(PiShare01Stroke, PiShare01Solid);
export const ShuffleIcon = createIcon(PiShuffleStroke, PiShuffleSolid);
export const SidebarLeftCloseIcon = createIcon(PiSidebarLeftCloseStroke);
export const SidebarRightCloseIcon = createIcon(PiSidebarRightCloseStroke);
export const SignInIcon = createIcon(PiLogInRightStroke, PiLogInRightSolid);
export const StarIcon = createIcon(PiStarStroke, PiStarSolid);
export const StarsIcon = createIcon(PiAI03Stroke, PiAI03Solid);
export const SuitcaseIcon = createIcon(PiBriefcaseJobStroke, PiBriefcaseJobSolid);
export const SyncIcon = createIcon(PiRefreshStroke, PiRefreshSolid);
export const TagIcon = createIcon(PiTagStroke, PiTagSolid);
export const TargetIcon = createIcon(PiFocusTargetStroke, PiTargetCenterSolid);
export const TextSizeIcon = createIcon(PiTextStroke);
export const UnderlineIcon = createIcon(PiUnderlineStroke);
export const UndoIcon = createIcon(PiUturnLeftStroke, PiUturnLeftSolid);
export const UploadIcon = createIcon(PiUploadUpStroke, PiUploadUpSolid);
export const UserArrowRightIcon = createIcon(PiUserArrowRightStroke);
export const UserCheckIcon = createIcon(PiUserCheckStroke);
export const UserHeartIcon = createIcon(PiUserLoveHeartStroke, PiUserLoveHeartSolid);
export const UserPlusIcon = createIcon(PiUserPlusStroke, PiUserPlusSolid);
export const WarningIcon = createIcon(PiAlertTriangleStroke, PiAlertTriangleSolid);
export const PreviewIcon = createIcon(PiEyeOnStroke, PiEyeOnSolid);
export const CircleAddIcon = createIcon(PiPlusCircleStroke, PiPlusCircleSolid);
export const ViewIcon = createIcon(PiEyeOnStroke, PiEyeOnSolid);
export const VisibilityOffIcon = createIcon(PiEyeOffStroke, PiEyeOffSolid);
export const PathIcon = createIcon(PiDiamondComponentStroke, PiDiamondComponentSolid);
export const JustifyLeftIcon = createIcon(PiAlignLeftStroke, PiAlignLeftSolid);
export const JustifyRightIcon = createIcon(PiAlignRightStroke, PiAlignRightSolid);
export const JustifyCenterIcon = createIcon(
	PiAlignHorizontalCenterStroke,
	PiAlignHorizontalCenterSolid,
);
export const JustifyAllIcon = createIcon(PiTextParagraphStroke, PiTextParagraphSolid);
